import Skeleton from "@mui/material/Skeleton";

interface LoadingOrValueProps {
  value: string | number | undefined | null;
  loading: boolean;
  error?: boolean;
  height: number | string;
  width: number | string;
  prefix?: React.ReactNode;
}

export const LoadingOrValue: React.FC<LoadingOrValueProps> = ({
  value,
  loading,
  error,
  height,
  width,
  prefix,
}) => {
  if (loading)
    return <Skeleton height={height} width={width} variant="rectangular" />;

  if (error || !value) return <span>Unknown</span>;

  return (
    <span>
      {prefix ?? ""}
      {value}
    </span>
  );
};

export default LoadingOrValue;
